module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.$style.root
  }, [_c('button', {
    class: _vm.getClasses(),
    attrs: {
      "type": _vm.type,
      "disabled": _vm.internalDisabled,
      "data-test": _vm.dataTest
    },
    on: {
      "click": _vm.onClick
    }
  }, [(_vm.iconLeft) ? [_c('icon', {
    staticClass: "icon left",
    attrs: {
      "name": this.iconLeft,
      "scale": _vm.iconSize
    }
  })] : _vm._e(), (_vm.$slots.default) ? _c('span', [_vm._t("default")], 2) : _vm._e(), (_vm.iconRight) ? [_c('icon', {
    staticClass: "icon right",
    attrs: {
      "name": this.iconRight,
      "scale": _vm.iconSize
    }
  })] : _vm._e(), (_vm.loading) ? _c('icon', {
    staticClass: "icon right",
    attrs: {
      "name": "spinner",
      "scale": _vm.iconSize,
      "spin": true
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0f89b8a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/gotu-nav-button/GotuNavButton.vue
// module id = 2082
// module chunks = 1